import React, { createContext, useContext, useMemo } from 'react';
const ChartCtx = createContext(undefined);
export const ChartContextProvider = ({ children, height, width, marginBottom = 16, marginLeft = 16, marginRight = 16, marginTop = 16, xScale, yScale, y0, svgRef, ticksCount }) => {
    const value = useMemo(() => ({
        height,
        width,
        marginBottom,
        marginLeft,
        marginRight,
        marginTop,
        xScale,
        yScale,
        y0,
        svgRef,
        ticksCount
    }), [
        height,
        marginBottom,
        marginLeft,
        marginRight,
        marginTop,
        svgRef,
        ticksCount,
        width,
        xScale,
        y0,
        yScale
    ]);
    return React.createElement(ChartCtx.Provider, { value: value }, children);
};
export const useChartCtx = () => {
    const context = useContext(ChartCtx);
    if (!context) {
        throw new Error('You may have forgot to render <ChartContextProvider /> because ChartCtx is not defined');
    }
    return context;
};
